import Store from '../../../store'
import API from './api'
import AdvancedSearch from './advanced-search.vue'

Store.registerModule('search', {
  namespaced: true,
  state: {
    query: '',
    total: 0,
    current: 1,
    results: [],
    pageSize: null,
    numberOfResults: 0,
  },
  mutations: {
    search(state, query = '') {
      if (!query) {
        return
      }
      API.search({
        SearchTerm: query,
        PageSize: state.pageSize,
        CurrentPage: 1
      }).then(data => Object.assign(state, {
        query,
        total: data.NumberOfPages,
        current: 1,
        results: data.results,
        numberOfResults: data.NumberOfResults
      }))
    },
    paginate(state, current) {
      API.search({
        SearchTerm: state.query,
        PageSize: state.pageSize,
        CurrentPage: current,
      }).then(data => Object.assign(state, {
        current,
        results: data.results,
        numberOfResults: data.NumberOfResults
      }))
    }
  }
})

export default AdvancedSearch
